export const hospitalHimCptColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'code_description',
  'cpt',
  'fk_hospital__data_doc_new_id',
  'is_duplicate_cpt',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'modifier1',
  'modifier2',
  'modifier3',
  'modifier4',
  'performing_physician__code',
  'performing_physician__name',
  'performing_physician__npi',
  'performing_physician__specialty',
  'revenue_code',
  'sequence',
  'service_date',
  'snapshot_id',
  'update_date_time',
  'visit_transaction_return_identifier1',
  'visit_transaction_return_identifier2',
  'visit_transaction_return_identifier3',
];
